module.exports = __webpack_public_path__ + "img/szechenyi.e0079018.svg";